import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { authFetch } from "../../App";
import { Building2, ChevronRight, ClipboardCheck } from "lucide-react";

const API = "/api";

export default function HpsObjekte() {
  const [customers, setCustomers] = useState([]);
  const [objects, setObjects] = useState([]);
  const [inspections, setInspections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const [c, o, i] = await Promise.all([
          authFetch(`${API}/hps/customers`).then(r => r.json()),
          authFetch(`${API}/hps/objects`).then(r => r.json()),
          authFetch(`${API}/hps/inspections`).then(r => r.json()),
        ]);
        setCustomers(Array.isArray(c) ? c : []);
        setObjects(Array.isArray(o) ? o : []);
        setInspections(Array.isArray(i) ? i : []);
      } finally { setLoading(false); }
    })();
  }, []);

  if (loading) return <div className="text-white/60 text-sm py-20 text-center">Lade …</div>;

  return (
    <div className="space-y-6" data-testid="hps-objekte">
      <div>
        <h1 className="text-2xl font-semibold text-white">Objekte & Prüfungen</h1>
        <p className="text-sm text-white/55 mt-1">Übersicht aller Kunden, Liegenschaften und durchgeführten Prüfungen</p>
      </div>

      <div className="space-y-4">
        {customers.map((c) => {
          const custObjs = objects.filter((o) => o.customer_id === c.id);
          return (
            <div key={c.id} className="rounded-xl border border-white/10 p-5"
                 style={{ background: "rgba(255,255,255,0.04)" }}>
              <div className="flex items-center gap-2 mb-3">
                <span className="text-sm font-semibold text-white">{c.name}</span>
                {c.is_demo && <span className="text-[10px] uppercase tracking-wider text-amber-300 bg-amber-500/15 border border-amber-400/30 rounded px-1.5 py-0.5">Demo</span>}
              </div>
              <div className="space-y-2">
                {custObjs.map((obj) => {
                  const objInspections = inspections.filter((i) => i.object_id === obj.id);
                  return (
                    <div key={obj.id} className="rounded-lg border border-white/10 p-3"
                         style={{ background: "rgba(255,255,255,0.02)" }}
                         data-testid={`hps-object-${obj.id}`}>
                      <div className="flex items-start gap-3">
                        <Building2 className="w-4 h-4 text-blue-300 mt-1 shrink-0" />
                        <div className="flex-1 min-w-0">
                          <div className="text-sm text-white font-medium">{obj.name}</div>
                          <div className="text-xs text-white/50 mt-0.5">
                            {obj.address && `${obj.address}, `}{obj.zip_code} {obj.city}
                          </div>
                        </div>
                      </div>
                      <div className="mt-3 space-y-1.5 pl-7">
                        {objInspections.length === 0 && (
                          <div className="text-xs text-white/40 italic">Noch keine Prüfungen.</div>
                        )}
                        {objInspections.map((ins) => (
                          <Link key={ins.id}
                                to={`/app/hps-anlagencheck/pruefung/${ins.id}`}
                                data-testid={`hps-inspection-link-${ins.id}`}
                                className="flex items-center justify-between gap-3 text-xs rounded-md px-3 py-2 bg-white/5 hover:bg-white/10 border border-white/5 transition-colors group">
                            <div className="flex items-center gap-2 min-w-0">
                              <ClipboardCheck className="w-3.5 h-3.5 text-blue-300 shrink-0" />
                              <span className="text-white/85 truncate">{ins.title}</span>
                              <span className="text-white/40">·</span>
                              <span className="text-white/50">{ins.inspection_date}</span>
                            </div>
                            <ChevronRight className="w-3.5 h-3.5 text-white/40 group-hover:text-white/80 shrink-0" />
                          </Link>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
